// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.text-middle,\n.el-table td.text-middle {\n  width: 7.5em;\n}", ""]);
// Exports
module.exports = exports;
